module.exports = __webpack_public_path__ + "static/media/22ESCWA4.34a40cb1.jpg";